import {
	Popups
} from '../popup/popups';
import cookies from '../../plugins/cookies';

class DataActionBtn {
	constructor() {}
	init($root = document) {
		this.actionBtns = $root.querySelectorAll('[data-action]');
		this.actionsPopupArr = [];
		for (let i = 0; i < this.actionBtns.length; i++) {
			const Btn = this.actionBtns[i];
			let dataActionAttr = Btn.getAttribute('data-action').split('_');

			let dataAction = dataActionAttr[0];

			let dataActionTarget = dataActionAttr[1];

			switch (dataAction) {
				case 'popup':

					if (!this.actionsPopupArr[dataActionTarget]) this.actionsPopupArr[dataActionTarget] = [];
					this.actionsPopupArr[dataActionTarget].push(Btn);

					break;
				case 'contrast':
					if (localStorage.getItem('contrast')) {
						document.querySelector('body').classList.add('contrast');
					} else {
						document.querySelector('body').classList.remove('contrast');
					}
					Btn.addEventListener('click', this.contrastEvent);
					break;
				case 'cookies':
					if (cookies.getCookie('cookies_accepted') != 'T') {
						document.querySelector('[data-cookie]').style.display = "block";
						Btn.addEventListener('click', this.removeCookie);
					}
					break;
				case 'print':
					Btn.addEventListener('click', this.printEvent);
					break;
				case 'oldNetia':
					cookies.setCookie("ilikenetia", "false", 30, ";domain=.netia.pl");
					window.location.href = 'http://netia.pl';

					break;
				default:

					break;
			}
		}

		this.createPopups = new Popups(this.actionsPopupArr);

		// console.log('daction inited', this.createPopups, dAction);
	}
	resizePopups() {
		return this.createPopups.resize();
	}

	contrastEvent(e) {
		e.preventDefault();
		const contrastSpan = e.target.parentNode.querySelector('.sr-only');
		if (!localStorage.getItem('contrast')) {
			document.querySelector('body').classList.add('contrast');
			localStorage.setItem('contrast', 'true');
			contrastSpan.innerHTML = contrastSpan.getAttribute('data-text-nocontrast');
		} else {
			document.querySelector('body').classList.remove('contrast');
			localStorage.removeItem('contrast');
			contrastSpan.innerHTML = contrastSpan.getAttribute('data-text-contrast');
		}
	}

	printEvent(e) {
		e.preventDefault();
		window.print();
	}

	removeCookie(e) {
		e.preventDefault();
		let cookie_el = document.querySelector('[data-cookie]');
		cookies.setCookie('cookies_accepted', 'T', cookie_el.getAttribute('data-cookie'));
		cookie_el.style.display = "none";
	}




}

const dAction = new DataActionBtn();

export {
	dAction
};
